import {EditPopup} from "../Detail2/components/EditPopup";
import {useLocation} from "react-router-dom";

export const Create = () => {
    const {pathname} = useLocation()

    return <EditPopup id={-1} tableName={pathname.split('/')[1] + "_"}/>
}